import { MenuItem, MenuItemType } from './layout-menu.models';
import { Permission } from 'src/app/modules/roles/constants/roles.constants';

export const LAYOUT_MENU_ITEMS: MenuItem[] = [
  {
    text: 'Inicios de sesión',
    link: ['/dashboard', 'log-ins'],
    icon: 'login',
    permission: Permission.ReadLogIns,
    type: MenuItemType.Single,
    isAvailableWhileOffline: false,
  },
  {
    text: 'Usuarios',
    link: ['/dashboard', 'users'],
    icon: 'person',
    permission: Permission.ManageUsers,
    type: MenuItemType.Single,
    isAvailableWhileOffline: false,
  },
  {
    text: 'Grupos',
    link: ['/dashboard', 'groups'],
    icon: 'groups',
    permission: Permission.ManageGroups,
    type: MenuItemType.Single,
    isAvailableWhileOffline: false,
  },
  {
    text: 'Plantillas',
    link: ['/dashboard', 'templates'],
    icon: 'newspaper',
    permission: Permission.ReadTemplates,
    type: MenuItemType.Single,
    isAvailableWhileOffline: false,
  },
  {
    text: 'Órdenes',
    link: ['/dashboard', 'orders'],
    icon: 'assignment',
    permission: Permission.ReadOrders,
    type: MenuItemType.Section,
    subsections: [],
    expand: false,
    isAvailableWhileOffline: true,
  },
  {
    text: 'Máquinas',
    link: ['/dashboard', 'machines'],
    icon: 'agriculture',
    permission: Permission.ManageMachines,
    type: MenuItemType.Single,
    isAvailableWhileOffline: false,
  },
  {
    text: 'Asignaciones',
    link: ['/dashboard', 'assignments'],
    icon: 'assignment_turned_in',
    permission: Permission.ReadAssignments,
    type: MenuItemType.Single,
    isAvailableWhileOffline: false,
  },
  {
    text: 'Averías y mantenimientos',
    link: ['/dashboard', 'issues'],
    icon: 'build',
    permission: Permission.ReadIssues,
    type: MenuItemType.Single,
    isAvailableWhileOffline: false,
  },
  {
    text: 'Repuestos',
    link: ['/dashboard', 'spares'],
    icon: 'home_repair_service',
    permission: Permission.ManageSpares,
    type: MenuItemType.Section,
    isAvailableWhileOffline: false,
    subsections: [
      {
        text: 'Gestión',
        link: ['/dashboard', 'spares'],
        permission: Permission.ManageSparesOverview,
      },
      {
        text: 'Solicitudes',
        link: ['/dashboard', 'spares-requests'],
        permission: Permission.ReadSparesRequests,
      },
    ],
  },
];
